import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";

import "./index.css";
import { App } from "./App.tsx";
import { UpdateBanner } from "./components/UpdateBanner.tsx";
import { queryClient } from "./lib/queryClient.ts";

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("Falta #root en index.html");

createRoot(rootEl).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
        <UpdateBanner />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
